export default __webpack_public_path__ + "static/media/fc_icon_great.5886bbd2.svg";